import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=5a7b2385&"
import script from "./TransactionList.vue?vue&type=script&lang=js&"
export * from "./TransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a7b2385')) {
      api.createRecord('5a7b2385', component.options)
    } else {
      api.reload('5a7b2385', component.options)
    }
    module.hot.accept("./TransactionList.vue?vue&type=template&id=5a7b2385&", function () {
      api.rerender('5a7b2385', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pacs008/SCT/TransactionList.vue"
export default component.exports